import { withState } from 'recompose';

export default withState(
  'confirmDeleteModal',
  'updateConfirmDeleteModal',
  false
);
